"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Declarative_1 = require("../../utils/Declarative");
var SliderStyles_1 = require("./SliderStyles");
/**
 * The slider track appears underneath the slider handles in the slider widget.  This component itself is not
 * interactive, but the track can seem like its interactive since the SliderHandleContainer is positioned on top of
 * it and does let you click anywhere in the track to grab the handles.
 */
function SliderTrackWidget(props) {
    var styles = SliderStyles_1.getSliderTrackStyles();
    var indicatorBar;
    if (props.rangeIndicatorBarPosition) {
        var leftPositionAsPercentage = props.rangeIndicatorBarPosition.start * 100;
        var rightPositionAsPercentage = (1 - props.rangeIndicatorBarPosition.end) * 100;
        var style = props.handleIsBeingDragged ? styles.RangeIndicatorBarDarkened :
            (props.isRangeHandleFocused ? styles.RangeIndicatorBarFocused : styles.RangeIndicatorBar);
        indicatorBar = React.createElement("div", { style: tslib_1.__assign(tslib_1.__assign({}, style), { left: leftPositionAsPercentage + "%", right: rightPositionAsPercentage + "%" }) });
    }
    var dataBar;
    if (props.dataBarPosition) {
        var leftPositionAsPercentage = props.dataBarPosition.start * 100;
        var rightPositionAsPercentage = (1 - props.dataBarPosition.end) * 100;
        var style = props.handleIsBeingDragged ? styles.DataBarDarkened :
            (props.isRangeHandleFocused ? styles.DataBarFocused : styles.DataBar);
        dataBar = React.createElement("div", { style: tslib_1.__assign(tslib_1.__assign({}, style), { left: leftPositionAsPercentage + "%", right: rightPositionAsPercentage + "%" }) });
    }
    return (React.createElement("div", { style: styles.Track, "data-tb-test-id": Declarative_1.makeTestId(props.testId, 'SliderTrack') },
        indicatorBar,
        dataBar));
}
exports.SliderTrackWidget = SliderTrackWidget;
//# sourceMappingURL=SliderTrackWidget.js.map